import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-2xl border font-semibold tracking-tight transition-all duration-normal ease-standard focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-60",
  {
    variants: {
      variant: {
        default:
          "border-border-default bg-surface-0 text-neutral-950 shadow-sm hover:border-primary-200 hover:bg-primary-50/70 hover:text-primary-700",
        primary:
          "border-transparent bg-primary-500 text-text-inverse shadow-lg hover:bg-primary-400",
        secondary:
          "border border-primary-100 bg-primary-50 text-primary-700 shadow-sm hover:border-primary-200 hover:bg-primary-100",
        neutral:
          "border border-neutral-200 bg-neutral-50 text-text-high shadow-sm hover:border-neutral-300 hover:bg-neutral-100",
        success:
          "border-transparent bg-success text-text-inverse shadow-lg hover:bg-success/90",
        info:
          "border-transparent bg-info text-text-inverse shadow-lg hover:bg-info/90",
        warning:
          "border-transparent bg-warning text-text-inverse shadow-lg hover:bg-warning/90",
        danger:
          "border-transparent bg-danger text-text-inverse shadow-lg hover:bg-danger/90",
        disabled:
          "border border-neutral-100 bg-neutral-100 !text-neutral-400 cursor-not-allowed",
        outline:
          "border border-border-default bg-transparent text-neutral-950 hover:border-primary-200 hover:bg-primary-50/60 hover:text-primary-700",
        ghost:
          "border border-transparent bg-transparent text-text-secondary hover:bg-neutral-100 hover:text-neutral-950",
        link:
          "border-transparent bg-transparent px-0 text-primary-500 underline-offset-4 hover:text-primary-400 hover:underline",
        icon:
          "border border-border-default bg-surface-0 text-text-secondary shadow-sm hover:bg-primary-50 hover:text-primary-700",
      },
      size: {
        default: "h-11 px-5 text-sm",
        sm: "h-9 rounded-xl px-3 text-xs",
        lg: "h-12 rounded-[28px] px-7 text-base",
        icon: "h-11 w-11 rounded-2xl p-0",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);
